/** @jsxImportSource theme-ui */

// This is shadowed by the CMS
export default function useMenuQuery({ locale }) {
  return [];
}
